import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { cn } from '../utils/cn';
/**
 * Beschriftetes Eingabefeld (MUI-`TextField`-Ersatz): FormControl-Gruppe aus
 * Label + `.sec-input` + Helper/Fehlertext, korrekt per `htmlFor`/`aria-describedby`
 * verknuepft. Nimmt alle nativen `<input>`-Props entgegen.
 */
export const TextField = forwardRef(function TextField({ label, helperText, error, id, type = 'text', className, ...rest }, ref) {
    const autoId = useId();
    const fieldId = id ?? autoId;
    const helperId = helperText != null ? `${fieldId}-helper` : undefined;
    return (_jsxs("div", { className: cn('sec-form-control', error && 'sec-form-control--error'), children: [label != null && (_jsx("label", { className: "sec-label", htmlFor: fieldId, children: label })), _jsx("input", { ref: ref, id: fieldId, type: type, className: cn('sec-input', error && 'sec-input--error', className), "aria-invalid": error || undefined, "aria-describedby": helperId, ...rest }), helperText != null && (_jsx("p", { id: helperId, className: cn('sec-helper-text', error && 'sec-helper-text--error'), children: helperText }))] }));
});
